import api from '..'
import { ExternalCourseModelAPI } from '../../models/externalCourse.model'

const getCourse = (id: number | string) => {
  return api
    .get<ExternalCourseModelAPI>(`external_courses/${id}`)
    .then(({ data }) => {
      return data
    })
}

export default getCourse
